var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"colored-letter-square",style:({backgroundColor: _vm.bgcolor})},[_vm._v("\n    "+_vm._s(_vm.initials)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }